enum AuthStatus {
  AUTHENTICATION_CHECKING = 'AUTHENTICATION_CHECKING',
  AUTHENTICATION_PROCESS = 'AUTHENTICATION_PROCESS',
  AUTHENTICATION_SUCCESSFUL = 'AUTHENTICATION_SUCCESSFUL',
  SWITCHING_ROLE = 'SWITCHING_ROLE',
  NOT_AUTHENTICATED = 'NOT_AUTHENTICATED',
}

export default AuthStatus;
